import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var PieChartAlt2 = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9H13V4.069A8.008 8.008 0 0119.931 11zM4 12c0-4.072 3.061-7.436 7-7.931V12a.996.996 0 00.111.438c.015.03.022.063.041.093l4.202 6.723A7.949 7.949 0 0112 20c-4.411 0-8-3.589-8-8zm13.052 6.196L13.805 13h6.126a7.992 7.992 0 01-2.879 5.196z",
    key: "k0"
  }));
});
PieChartAlt2.displayName = 'PieChartAlt2';
export var PieChartAlt2Dimensions = {
  height: 24,
  width: 24
};